import { HorizontalDivider } from "components";
import PixPayment from "./PixPayment/PixPayment.component";

export * from "./CardsFlags/CardsFlags.component";
export * from "./Installments/Installments.component";
export * from "./Root";
export * from "../PaymentMethods.styles";

export { HorizontalDivider, PixPayment };
